export const FILTER_OFFER_EVENT = 'hotels_info_with_filtering:apply_offer'

export const FILTERS_IN_PARAMS = [
  'filter_destinations',
  'filter_categories',
  'filter_amenities',
  'filter_specialties',
  'filter_offers',
]
